import { Button, Icon, Spinner, Text } from "@alpacahq/ui/old";

import { FAQ } from "../../../../../components/common/FAQ";
import { BankLinkageAlert } from "../../common/BankLinkageAlert";
import { Layout } from "../../common/Layout";
import { WIRE_FAQ } from "../../link/wire";
import { FromTo } from "../../transferForm/FromTo";
import { ReasonFields } from "../../transferForm/ReasonFields";
import { TransferFormButtons } from "../../transferForm/TransferFormButtons";
import { TransferFormFields } from "../../transferForm/TransferFormFields";
import { IraDistributionFields } from "../ira/IraDistributionFields";
import type { useWireWithdrawController } from "./WireWithdraw.controller";

export type WireWithdrawPresentationProps = ReturnType<
  typeof useWireWithdrawController
>;

export const WireWithdrawPresentation = ({
  isLoading,
  hasWireRelationship,
  wireRelationship,
  isBankLinkageDisallowed,
  alpacaAccountInfo,
  form,
  isIRA,
  eligibleReasons,
  isSubmitChecked,
  setIsSubmitChecked,
  isSubmitEnabled,
  isConfirmDisabled,
  amountString,
  withdrawable,
  onBack,
  onSubmit,
}: WireWithdrawPresentationProps) => {
  const backButton = (
    <Button variant="secondary" onClick={onBack} className="mb-8">
      <Icon name="ArrowLeftCircle" className="mr-2" />
      Back
    </Button>
  );

  return (
    <Layout
      title="Withdraw Funds via Wire"
      subtitle="Withdraw funds from your Alpaca account using Wire connection."
      className="p-2"
      faq={<FAQ faq={WIRE_FAQ} />}
    >
      {isLoading ? (
        <Spinner className="mx-auto" />
      ) : !hasWireRelationship ? (
        <div className="flex flex-col gap-4">
          <Text>
            {wireRelationship?.status === "REJECTED"
              ? "Wire connection has been rejected."
              : "No Wire connection Found."}
          </Text>
          {backButton}
        </div>
      ) : (
        <>
          {backButton}
          {isBankLinkageDisallowed ? (
            <BankLinkageAlert />
          ) : (
            <form
              onSubmit={onSubmit}
              className="w-full max-w-lg rounded border border-gray-200 p-4"
            >
              <FromTo
                from={alpacaAccountInfo}
                to={{
                  name: wireRelationship?.name ?? "",
                  account: wireRelationship?.account_number ?? "",
                }}
                className="mb-8"
              />
              {isIRA ? (
                <>
                  <IraDistributionFields
                    form={form}
                    eligibleReasons={eligibleReasons}
                    areInputsDisabled={isSubmitChecked}
                  />
                  <TransferFormFields
                    form={form}
                    isInputDisabled={isSubmitChecked}
                    withdrawableAmount={withdrawable}
                  />
                </>
              ) : (
                <>
                  <TransferFormFields
                    form={form}
                    isInputDisabled={isSubmitChecked}
                    withdrawableAmount={withdrawable}
                  />
                  <ReasonFields form={form} withdrawableAmount={withdrawable} />
                </>
              )}
              <TransferFormButtons
                direction="withdrawal"
                isSubmitChecked={isSubmitChecked}
                setIsSubmitChecked={setIsSubmitChecked}
                isSubmitEnabled={isSubmitEnabled}
                isConfirmDisabled={isConfirmDisabled}
                amount={amountString}
              />
            </form>
          )}
        </>
      )}
    </Layout>
  );
};
